import mitt, { type Emitter, type EventType } from "mitt";

// type Events = {
//     showSearchOverlay: boolean;
//   };
// export const emitterInstance: Emitter<Events> = mitt();
export const emitterInstance = mitt();
